import { render } from "./ProblemCards.vue?vue&type=template&id=451c8a6f&scoped=true"
import script from "./ProblemCards.vue?vue&type=script&lang=js"
export * from "./ProblemCards.vue?vue&type=script&lang=js"

import "./ProblemCards.vue?vue&type=style&index=0&id=451c8a6f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451c8a6f"]])

export default __exports__